// Native scrollable menus; Phaser retains gameplay, audio and progress.
import { GAME_MODE, getGameMode } from '../systems/GameMode';
export function element(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = String(text);
  return node;
}
export function button(label, action, className = 'tmag-button') {
  const node = element('button', className, label);
  node.type = 'button';
  node.addEventListener('click', action);
  return node;
}
export function mountMenu(scene, className = '') {
  scene.menuLeaving = false;
  const root = element('section', `tmag-menu ${className}`);
  root.style.setProperty('--menu-sky', 'url("/assets/bg_deepspace.jpg")');
  root.style.setProperty('--menu-planet', 'url("/assets/bg_planet.jpg")');
  root.style.setProperty('--launch-background', 'url("/assets/bg_launch_base.jpg")');
  root.style.setProperty('--resta-background', 'url("/assets/bg_resta_day.jpg")');
  root.style.setProperty('--mult-background', 'url("/assets/bg_multiplicacion_forest.webp")');
  root.tabIndex = -1;
  scene.game.canvas.parentElement.appendChild(root);
  // Let native buttons handle Enter/Space without also firing Phaser shortcuts.
  const keyboard = scene.input.keyboard;
  const wasEnabled = keyboard.enabled;
  keyboard.enabled = false;
  root.focus({ preventScroll: true });
  const cleanup = () => {
    root.remove();
    keyboard.enabled = wasEnabled;
    scene.events.off('shutdown', cleanup);
    scene.events.off('destroy', cleanup);
  };
  scene.events.once('shutdown', cleanup);
  scene.events.once('destroy', cleanup);
  return root;
}
export function header(root, title, subtitle, backLabel, backAction) {
  const head = element('header', 'tmag-menu-header');
  if (backAction) head.append(button(backLabel, backAction, 'tmag-button tmag-back'));
  head.append(element('h1', 'tmag-title', title));
  if (subtitle) head.append(element('p', 'tmag-subtitle', subtitle));
  root.append(head);
  return head;
}
export function modeBadge(scene) {
  const isPractice = getGameMode(scene.registry) === GAME_MODE.PRACTICE;
  return element(
    'span',
    `tmag-mode-badge tmag-mode-badge--${isPractice ? 'practice' : 'competition'}`,
    isPractice ? '🎯 PRÁCTICA' : '🚀 AVENTURA',
  );
}
export function rows(root, entries) {
  const list = element('dl', 'tmag-stats');
  entries.forEach(([label, value, rowClass = '']) => {
    const row = element('div', ['tmag-stat', rowClass].filter(Boolean).join(' '));
    row.append(element('dt', '', label), element('dd', '', value));
    list.append(row);
  });
  root.append(list);
}
export function go(scene, target, prepare) {
  if (scene.menuLeaving) return;
  scene.menuLeaving = true;
  if (prepare) prepare();
  scene.scene.start(target);
}
export function primaryShortcut(root, action) {
  root.addEventListener('keydown', event => {
    if (event.target === root && (event.code === 'Space' || event.code === 'Enter')) {
      event.preventDefault();
      action();
    }
  });
}
